import { getAuth } from "firebase/auth";
import { firebaseApp } from "./firebase";

type UserNotification = {
  id: string;
  title: string;
  text: string;
  type: "fail" | "information";
  icon: string;
};

type NotificationSettings = {
  email: boolean;
  sms: boolean;
};

type NotificationTasks = {
  videoRendered: NotificationSettings;
  transcriptionComplete: NotificationSettings;
};

type NotificationsSettings = {
  tasks: NotificationTasks;
};

type UserSettings = {
  notifications: NotificationsSettings;
};
export interface UserDetails {
  firstName: string;
  lastName: string;
  phone: string;
  role: string;
  thumbnail: string;
  onboarded: boolean;
  uid: string;
  consents: { type: string }[];
  registerDate: string;
  workspaces: any[];
  selectedWorkspace: any;
  notification?: UserNotification;
  settings: UserSettings;
}

export interface AuthError {
  code: "user-deleting" | "user-banned" | "unknown";
}

export const fetchUserDetailsAPI = async (): Promise<UserDetails> => {
  const auth = getAuth(firebaseApp);
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No user is currently signed in.");
  }

  try {
    const token = await user.getIdToken();
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_ENDPOINT}/user/details?token=${token}`
    );
    const data = await response.json();

    if (!response.ok) {
      throw data.error;
    }

    return data.result;
  } catch (error) {
    throw error;
  }
};
